import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';
import { service } from '@ember/service';
import type OrganisationService from 'scaleflow/services/organisation';
import type StoreService from 'scaleflow/services/store';
import type RouterService from '@ember/routing/router-service';
import type BetaToggleService from 'scaleflow/services/beta-toggle';

class CompanyRoute extends Route {
  @service declare organisation: OrganisationService;
  @service declare store: StoreService;
  @service declare router: RouterService;
  @service declare betaToggle: BetaToggleService;

  beforeModel() {
    return Promise.allSettled([
      this.store.findAll('goal'),
      this.store.findAll('initiative'),
      this.store.findAll('theme'),
      this.store.findAll('metric'),
    ]);
  }

  model() {
    return this.organisation.organisation;
  }
}

export default instrumentRoutePerformance(CompanyRoute);
